import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Grid,
  Header,
  Icon,
  Input,
  Item,
  Menu,
  Modal,
  Table,
  TextArea,
} from "semantic-ui-react";
import LasServiceApi from "../../api/lasService";
import Logo from "../../components/Logo/Logo";

import { useAppDispatch as useDispatch } from "../../hooks/redux";

import { setLasService } from "../../redux/actions/lasService";
import { LasServiceContractBase } from "../../types/lasServiceContractBase";

import { setEmail as setEmailRedux } from "../../redux/actions/admin";

import style from "./style.module.css";
import { downloadFile } from "../../utils/downloadFile";
import { contractTypeSupported } from "../../utils/contractType";
import { useUploadFile } from "../../hooks/useUploadFile";
import { validAliquota } from "../../utils/validAliquota";

export default function LasServiceTablePage() {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const [responsibleName, setResponsibleName] = useState("");
  const [responsibleEmail, setResponsibleEmail] = useState("");
  const [witnessName, setWitnessName] = useState("");
  const [witnessEmail, setWitnessEmail] = useState("");
  const [iva, setIva] = useState("");

  const [contract, setContract] = useState<LasServiceContractBase>();
  const [modalVisible, setModalVisible] = useState(false);
  const [keepConditionsModalVisible, setKeepConditionsModalVisible] =
    useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [keepConfirmationModal, setKeepConfirmationModal] = useState(false);
  const [problemModal, setProblemModal] = useState(false);
  const [problem, setProblem] = useState("");

  const { handleUploadFile, responseOk } = useUploadFile(contract?.id as number, contractTypeSupported.LAS_SERVICES, "las");

  const validateEmail = (email: string) => {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
  };
  const history = useHistory();
  const updatedContract = async () => {
    setLoading(true);
    setError("");
    try {
      await LasServiceApi.updateContract(
        responsibleName.trim(),
        responsibleEmail.trim(),
        witnessName.trim(),
        witnessEmail.trim(),
        iva
      );
      setConfirmationModal(true);
    } catch (err) {
      console.log(err);
      setError("problema al guardar");
    }
    setLoading(false);
  };

  const partialUpdatedContract = async () => {
    setLoading(true);
    setError("");
    try {
      await LasServiceApi.partialUpdateContract(
        responsibleName.trim(),
        responsibleEmail.trim(),
        witnessName.trim(),
        witnessEmail.trim(),
        iva
      );
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };
  const setKeepConditions = async (keepConditions: boolean) => {
    setLoading(true);
    setError("");
    try {
      await LasServiceApi.setKeepConditions(keepConditions);
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };
  const sendProblem = async () => {
    setLoading(true);
    setError("");
    try {
      await LasServiceApi.setProblem(problem);
      setProblemModal(true);
    } catch (err) {
      console.log(err);
      setError("problema al guardar");
    }
    setLoading(false);
  };
  const getContract = async () => {
    setLoading(true);
    try {
      const contract = await LasServiceApi.getContract();
      const mat = contract.lasServiceBases.sort(function (a, b) {
        let x = a.id;
        let y = b.id;
        return x < y ? -1 : x > y ? 1 : 0;
      });
      if (contract.keepConditions === null && contract.round === 0) {
        setKeepConditionsModalVisible(true);
      } else {
        setContract({ ...contract, lasServiceBases: mat });
        if (contract.lasServiceContractUpdate) {
          setResponsibleName(contract.lasServiceContractUpdate.responsibleName);
          setResponsibleEmail(
            contract.lasServiceContractUpdate.responsibleEmail
          );
          setWitnessName(contract.lasServiceContractUpdate.witnessName);
          setWitnessEmail(contract.lasServiceContractUpdate.witnessEmail);
          setIva(contract.lasServiceContractUpdate.iva ?? "");
        }
      }
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };

  const verifyForm = () => {
    if (
      responsibleName === "" ||
      responsibleEmail === "" ||
      witnessName === "" ||
      witnessEmail === "" ||
      iva === ""
    ) {
      return false;
    }
    if (!validateEmail(responsibleEmail) || !validateEmail(witnessEmail)) {
      return false;
    }
    return true;
  };

  const execDownloadFile = async () => {
		try {
      if (contract?.id) {
        downloadFile(contract.id.toString(), contractTypeSupported.LAS_SERVICES);
      }
		} catch (err) {
      console.log(err);
      setError("Problema ao exportar");
		}
	}

  useEffect(() => {
    getContract();
  }, []);

  useEffect(() => {
    if (responseOk) {      
      getContract();
    }
  }, [responseOk]);

  return (
    <div className={style.container}>
      <Modal
        onClose={() => {
          setProblemModal(false);
          dispatch(setEmailRedux(null));
          history.replace(`/loginLasService/${contract?.id}`);
        }}
        onOpen={() => setProblemModal(true)}
        open={problemModal}
      >
        <Modal.Header>Confirmação</Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <Header>
              Seu problema foi enviado com sucesso, logo entraremos em contato
            </Header>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button
            content="OK"
            labelPosition="right"
            icon="checkmark"
            onClick={() => {
              setProblemModal(false);
              dispatch(setEmailRedux(null));
              history.replace(`/loginLasService/${contract?.id}`);
            }}
            positive
          />
        </Modal.Actions>
      </Modal>

      <Modal
        onOpen={() => setKeepConditionsModalVisible(true)}
        open={keepConditionsModalVisible}
      >
        <Modal.Header>Aviso</Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <Header>
              ¿Podemos mantener las condiciones del contrato por un año
              adicional?
            </Header>
            <Grid.Column>
              <Grid.Row textAlign="left">
                <label>Nombre del responsable legal *: </label>
                <br />
                <label>(Persona que firmará el contrato) </label>
                <br />

                <Input
                  value={responsibleName}
                  onChange={(e) => {
                    setResponsibleName(e.target.value);
                  }}
                  onBlur={() => {
                    partialUpdatedContract();
                  }}
                  placeholder="responsable"
                />
              </Grid.Row>
              <br />

              <Grid.Row textAlign="left">
                <label>Email del responsable legal *: </label>
                <br />
                <Input
                  error={!validateEmail(responsibleEmail)}
                  value={responsibleEmail}
                  onChange={(e) => {
                    setResponsibleEmail(e.target.value);
                  }}
                  onBlur={() => {
                    partialUpdatedContract();
                  }}
                  placeholder="Email"
                />
              </Grid.Row>
              <br />

              <Grid.Row textAlign="left">
                <label>Nombre del testigo *: </label>
                <br />
                <label>(Cualquier outro empleado) </label>
                <br />
                <Input
                  value={witnessName}
                  onChange={(e) => {
                    setWitnessName(e.target.value);
                  }}
                  onBlur={() => {
                    partialUpdatedContract();
                  }}
                  placeholder="Nombre del testigo"
                />
              </Grid.Row>
              <br />

              <Grid.Row textAlign="left">
                <label>Email del testigo *: </label>
                <br />
                <Input
                  error={!validateEmail(witnessEmail)}
                  value={witnessEmail}
                  onChange={(e) => {
                    setWitnessEmail(e.target.value);
                  }}
                  onBlur={() => {
                    partialUpdatedContract();
                  }}
                  placeholder="Email"
                />
              </Grid.Row>
              <br />
            </Grid.Column>
            <p>
              Obs: Abriendo uma nueva negociacion la compañia podrá iniciar una
              nueva subasta.
            </p>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button
            loading={loading}
            content="Verificar condiciones"
            // labelPosition="right"
            onClick={async () => {
              await setKeepConditions(true);
              await getContract();
              await setKeepConditionsModalVisible(false);
            }}
            negative
          />
          <Button
            disabled={!verifyForm()}
            loading={loading}
            content="Mantener"
            // labelPosition="right"
            icon="checkmark"
            onClick={() => {
              setKeepConfirmationModal(true);
              setKeepConditionsModalVisible(false);
            }}
            positive
          />
        </Modal.Actions>
      </Modal>

      <Modal
        onOpen={() => setKeepConfirmationModal(true)}
        open={keepConfirmationModal}
      >
        <Modal.Header>Advertencia</Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <Header>
              Confirma que desea mantener las condiciones actuales?
            </Header>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button
            loading={loading}
            content="Cancelar"
            // labelPosition="right"
            onClick={async () => {
              setKeepConfirmationModal(false);
              setKeepConditionsModalVisible(true);
            }}
            negative
          />
          <Button
            disabled={!verifyForm()}
            loading={loading}
            content="Sim"
            // labelPosition="right"
            icon="checkmark"
            onClick={() => {
              setKeepConditions(true);
              updatedContract();
              setKeepConditionsModalVisible(false);
            }}
            positive
          />
        </Modal.Actions>
      </Modal>

      <Modal
        onClose={() => {
          setConfirmationModal(false);
          dispatch(setEmailRedux(null));
          history.replace(`/loginLasService/${contract?.id}`);
        }}
        onOpen={() => setConfirmationModal(true)}
        open={confirmationModal}
      >
        <Modal.Header>Confirmação</Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <Header>
              Su contrato fue enviado con éxito, entraremos en contacto
              finalizando la negociación o con una contraoferta
            </Header>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button
            content="OK"
            labelPosition="right"
            icon="checkmark"
            onClick={() => {
              setConfirmationModal(false);
              dispatch(setEmailRedux(null));
              history.replace(`/loginLasService/${contract?.id}`);
            }}
            positive
          />
        </Modal.Actions>
      </Modal>
      <Modal
        onClose={() => setModalVisible(false)}
        onOpen={() => setModalVisible(true)}
        open={modalVisible}
      >
        <Modal.Header>Problema</Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <Header>Estoy con problemas</Header>
            <p>Describa el problema</p>
          </Modal.Description>
          <TextArea
            cols="100"
            placeholder="Cuentanos mas sobre su problema"
            value={problem}
            onChange={(e, data) => {
              setProblem(data.value!.toString());
            }}
          />
        </Modal.Content>
        <Modal.Actions>
          <Button color="black" onClick={() => setModalVisible(false)}>
            Cancelar
          </Button>
          <Button
            content="Enviar y finalizar"
            labelPosition="right"
            icon="checkmark"
            onClick={() => {
              setModalVisible(false);
              sendProblem();
            }}
            positive
          />
        </Modal.Actions>
      </Modal>
      <Logo />
      <Button
        floated="right"
        loading={loading}
        color="red"
        onClick={() => setModalVisible(true)}
      >
        Estoy con problemas
      </Button>
      {/* <Header as="h1">Smart Contract</Header> */}

      <Grid columns={5} stackable>
        <Grid.Column>
          <Item.Group>
            <Item>
              <Item.Content>
                <Item.Header>Contrato</Item.Header>
                <Item.Meta>
                  <label>Numero:</label>
                  <span>{contract?.contractId}</span>
                  <br />
                  <label>Proveedor:</label>
                  <span>{contract?.supplierName}</span>
                  <br />
                  <label>Moneda:</label>
                  <span>{contract?.currency}</span>
                  <br />
                  <label>Código de impuestos:</label>
                  <span>{contract?.fiscalCode}</span>
                  <br />
                  <label>Centro:</label>
                  <span>{contract?.company}</span>
                  {/* <br />
                  <label>Prazo de pagamento:</label>
                  <span>{contract?.paymentTerm}</span> */}
                </Item.Meta>
                <Item.Description>{}</Item.Description>
              </Item.Content>
            </Item>
          </Item.Group>
        </Grid.Column>
        <Grid.Column>
          <Grid.Row textAlign="left">
            <label>Nombre del responsable legal *: </label>
            <br />
            <label>(Persona que firmará el contrato) </label>
            <br />

            <Input
              value={responsibleName}
              onChange={(e) => {
                setResponsibleName(e.target.value);
              }}
              onBlur={() => {
                partialUpdatedContract();
              }}
              placeholder="responsable"
            />
          </Grid.Row>
          <Grid.Row textAlign="left">
            <label>Email del responsable legal *: </label>
            <br />
            <Input
              error={!validateEmail(responsibleEmail)}
              value={responsibleEmail}
              onChange={(e) => {
                setResponsibleEmail(e.target.value);
              }}
              onBlur={() => {
                partialUpdatedContract();
              }}
              placeholder="Email"
            />
          </Grid.Row>
          <br />
        </Grid.Column>

        <Grid.Column>
          <Grid.Row textAlign="left">
            <label>Nombre del testigo *: </label>
            <br />
            <label>(Cualquier outro empleado) </label>
            <br />
            <Input
              value={witnessName}
              onChange={(e) => {
                setWitnessName(e.target.value);
              }}
              onBlur={() => {
                partialUpdatedContract();
              }}
              placeholder="Nombre del testigo"
            />
          </Grid.Row>
          <Grid.Row textAlign="left">
            <label>Email del testigo *: </label>
            <br />
            <Input
              error={!validateEmail(witnessEmail)}
              value={witnessEmail}
              onChange={(e) => {
                setWitnessEmail(e.target.value);
              }}
              onBlur={() => {
                partialUpdatedContract();
              }}
              placeholder="Email del testigo"
            />
          </Grid.Row>
          <br />
        </Grid.Column>
        <Grid.Column>
          <Grid.Row textAlign="left">
            <label>IVA %: *</label>
            <br />
            <Input
              value={iva}
              onChange={(e) => {
                if (validAliquota(e.target.value.replace(",", "."))) {
                  setIva(e.target.value.replace(",", "."));
                }
              }}
              onBlur={() => {
                if (isNaN(parseFloat(iva))) {
                  setIva("");
                } else {
                  setIva(parseFloat(iva).toFixed(2));
                }
                partialUpdatedContract();
              }}
              placeholder="IVA"
            />
          </Grid.Row>
          <br />
        </Grid.Column>
        <Grid.Column>
          <text>Complete todos los campos *</text>
          <br />
          {contract?.keepConditions === false ? (
            <Button
              loading={loading}
              primary
              disabled={!verifyForm()}
              onClick={updatedContract}
            >
              Enviar negociación
            </Button>
          ) : (
            <>
              <Button
                loading={loading}
                color="red"
                onClick={async () => {
                  await setKeepConditions(false);
                  await getContract();
                }}
              >
                Renegociar
              </Button>
              <Button
                loading={loading}
                color="green"
                disabled={!verifyForm()}
                onClick={updatedContract}
              >
                Activar
              </Button>
              <br />
              <text>
                Obs: Abriendo uma nueva negociacion la compañia podrá iniciar
                una nueva subasta
              </text>
            </>
          )}
          <br />
          <text className={style.error}>{error}</text>
        </Grid.Column>
      </Grid>
      <Grid.Column style={{display: "flex", justifyContent: "right"}}>          
        <Dropdown text="Negociación masiva" className="selection">
          <DropdownMenu>
            <DropdownItem text="Descargar Modelo" onClick={execDownloadFile}/>
            <DropdownItem text="Importar Excel" onClick={handleUploadFile}/>
          </DropdownMenu>
        </Dropdown>
      </Grid.Column>
      <Table>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Código</Table.HeaderCell>
            <Table.HeaderCell>Precio Actual</Table.HeaderCell>
            <Table.HeaderCell>Precio Propuesto</Table.HeaderCell>
            <Table.HeaderCell>Reajuste Percentual</Table.HeaderCell>
            <Table.HeaderCell>Descripcion</Table.HeaderCell>
            <Table.HeaderCell>Subdescripcion</Table.HeaderCell>
            {contract?.keepConditions === false ? (
              <Table.HeaderCell>Nuevo Precio (opcional)</Table.HeaderCell>
            ) : null}
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {contract?.lasServiceBases.map((service) => {
            return (
              <Table.Row key={service.service}>
                <Table.Cell>{service.service}</Table.Cell>
                <Table.Cell>
                  {service.price + " " + contract.currency}
                </Table.Cell>
                <Table.Cell>
                  {service.negotiationPrice
                    ? service.negotiationPrice + " " + contract.currency
                    : ""}
                </Table.Cell>
                <Table.Cell>
                  {service.negotiationPrice
                    ? (
                        (parseFloat(service.negotiationPrice) / service.price -
                          1) *
                        100
                      ).toFixed(2) + "%"
                    : ""}
                </Table.Cell>
                <Table.Cell>{service.description}</Table.Cell>
                <Table.Cell>{service.longDescription}</Table.Cell>

                {contract?.keepConditions === false ? (
                  <Table.Cell>
                    <Button
                      animated="vertical"
                      color={service.updated ? "yellow" : "grey"}
                      onClick={() => {
                        dispatch(setLasService(service));
                        history.push({
                          pathname: `/lasServiceContract/lasService`,
                        });
                      }}
                      disabled={service.discontinued || !iva}
                    >
                      <Button.Content visible>
                        {service.updated ? "Precio Propuesto" : "Nuevo Precio"}
                      </Button.Content>
                      <Button.Content hidden>
                        <Icon name="edit" />
                      </Button.Content>
                    </Button>
                  </Table.Cell>
                ) : null}
              </Table.Row>
            );
          })}
        </Table.Body>

        <Table.Footer fullWidth>
          <Table.Row>
            <Table.HeaderCell colSpan="7">
              <Menu floated="right" pagination>
                <Menu.Item
                  icon
                  onClick={() => {
                    //previus
                  }}
                >
                  <Icon name="chevron left" />
                </Menu.Item>
                <Menu.Item>{/* {page} of {totalPages} */}1 of 1</Menu.Item>
                <Menu.Item
                  icon
                  onClick={() => {
                    //onNextClick
                  }}
                >
                  <Icon name="chevron right" />
                </Menu.Item>
              </Menu>
            </Table.HeaderCell>
          </Table.Row>
        </Table.Footer>
      </Table>
    </div>
  );
}
